export const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug',
} as const;

export const LOG_COMPONENTS = {
  HTTP: 'http',
  AUTH: 'auth',
  SOCKET: 'socket',
  UI: 'ui',
  STORAGE: 'storage',
  API: 'api',
  CHAT: 'chat',
  SUBSCRIPTION: 'subscription',
  INTEGRATIONS: 'integrations',
  NOTIFICATION: 'notification',
  VENDOR: 'vendor',
  UTILS: 'utils',
} as const;

export const LOG_OPERATIONS = {
  REQUEST: 'IncomingRequest',
  RESPONSE: 'Response',
  ERROR: 'Error',
  AUTH: 'Authentication',
  SOCKET_CONNECT: 'SocketConnect',
  SOCKET_DISCONNECT: 'SocketDisconnect',
  SOCKET_ERROR: 'SocketError',
  UI_RENDER: 'UIRender',
  UI_INTERACTION: 'UIInteraction',
  STORAGE_READ: 'StorageRead',
  STORAGE_WRITE: 'StorageWrite',
  API_CALL: 'APICall',
  DEBUG: 'Debug',
} as const;
